<div #notesTemplate>
    <form [formGroup]="evolutionForm" (submit)="addEvolution($event)">
        <div class="evolutions-side-bar">
            <!-- HEADER - Button close -->
            <div class="flex-column caja-1 " style="top: 0 !important">
                <div class="flex-row align-space-between-center">
                    <div class="flex-row align-start-center text-primary pl-2">
                        <mat-icon style="margin-right: 1rem;">text_snippet</mat-icon>
                        <span style="font-size: 18px;">{{ ('modules.cases.evolutions-side-bar.notas' | exp:'':'Notas') }}</span>
                    </div>
                    <button id="evolutionsSideBarComponent_btnCloseSideBar" mat-icon-button (click)="this.close()"
                        [color]="'primary'">
                        <mat-icon class="mls-2">highlight_off</mat-icon>
                    </button>
                </div>
                <!-- <div > -->
                <app-select-input [name]="this.EVOLUTION_TYPE" [form]="this.evolutionForm"
                    [placeholder]="('modules.cases.evolutions-side-bar.header.placeholders.note-type' | exp:'':'Tipo de nota...')" [elements]="this.evolutionCategories"
                    [disabled]="(!this.case?.active || this.case?.rejected)"
                    [calculateId]="this.calculateCategoryOfEvolutionId" [noOptionText]="('modules.cases.evolutions-side-bar.sin-filtrar' | exp:'':'Sin filtrar')"
                    [calculateName]="this.calculateCategoryOfEvolutionName" (selected)="onSelectCategory($event)">

                </app-select-input>
                <!-- <mat-divider></mat-divider> -->
                @if(isLoadingGettingEvolutions && evolutionForm.get(this.NOTE).value == ""){
                <mat-progress-bar [mode]="'indeterminate'" [value]="100" ></mat-progress-bar>
                }
                <!-- </div> -->
            </div>

            <!-- --NOTE AREA  -->
            <div #myScroll class="flex-column caja-2">
                <div *ngFor="let entry of dataEvolutions | keyvalue">
                    <div *ngIf="entry.value.length > 0" style="height: 100%;;">
                        @if(referedNoteId === entry.value[entry.value.length -1].id){

                        <!-- Historial de versiones -->
                        <div>
                            <div class=" flex-100 flex-row align-center-center pxs-2">
                                <p class="flex-40 mrs-3" style="border:1.5px solid var(--color-grey-light); font-size: small"></p>
                                <mat-icon (click)="closeRef()" [style.width.px]="18" [style.height.px]="18"
                                    svgIcon="Xcircle" style="cursor: pointer;z-index: 20000;" > </mat-icon>
                                <span class="pbs-1 pls-2 subtitle-4 text-link">
                                    {{ ('modules.cases.evolutions-side-bar.version-history.hide-old-versions' | exp:'':'Ocultar versiones anteriores')  }}
                                </span>
                            </div>
                            <div *ngFor="let item of entry.value.slice().reverse()" style="height: fit-content;"
                                class="prs-2">
                                @if(item !== entry.value[0]){
                                <div [ngClass]="this.user.id === item.operatorId ? 'myself' : 'other'" class="flex-row"
                                    style="opacity: 0.75;">
                                    <!-- CARD -->
                                    <div class="flex-100">
                                        <!-- USER-->
                                        <div class="flex-row flex-100 pl-1"
                                            [ngClass]="this.user.id === item.operatorId ? 'start-none' : 'none-none'"
                                            style="height:15px !important; align-items: center !important ; justify-content: flex-start !important; width: 90%;">
                                            <p class="operatorName"
                                                style="text-overflow: ellipsis !important; white-space: nowrap; overflow: hidden;">
                                                {{ item.operator.name }}</p>
                                            <p
                                                style="text-overflow: ellipsis !important; white-space: nowrap; padding-left: 1%; font-size: 10px !important">
                                                - {{ item.category.category == 'NOTA_' ? 'NOTA' : item.category.category
                                                }}
                                            </p>
                                        </div>
                                        <!-- TEXTO -->
                                        <div class="flex-row">
                                            <app-theme-card themeScope="cases" [fullWidth]="false" [cardClass]="{
                                                    'bg-primary': this.user.id === item.operatorId,
                                                    'bg-primary-100': this.user.id !== item.operatorId,
                                                    'noteDeleted': !item.active
                                                }" [cardStyle]="{ 'border-radius': '10px', width: '350px' }">
                                                <mat-card-content class="mat-font-small-11px" [ngStyle]="{
                                                    'color': this.user.id === item.operatorId ? 'white' : 'black',
                                                  }" style="overflow-wrap: anywhere;"
                                                    [innerHTML]="item.active ? item.text : ('modules.cases.evolutions-side-bar.nota-eliminada' | exp:'':'Nota eliminada') | safeHtml">
                                                </mat-card-content>
                                                @if(!!item?.hasMedia){
                                                <div class="flex mat-font-small-11px p-4" (click)="downloadMedia(item)"
                                                    [ngStyle]="{'color': this.user.id === item.operatorId ? 'white' : 'black' }"
                                                    style="justify-content: end;font-size: 10px;">
                                                    <span style="cursor:pointer"><u>{{ 'modules.cases.evolutions-side-bar.card.text.see-attached' | exp:'':'Ver adjunto' }}</u></span>
                                                </div>
                                                }
                                            </app-theme-card>
                                        </div>
                                        <!-- TEXTO SI HAY ATENCIÓN -->
                                        <div *ngIf="item.attentionId" class="flex-column"
                                            [ngClass]="this.user.id === item.operatorId ? 'start-none' : 'none-none'">
                                            <div>
                                                <p class="mat-font-xsmall-px pl-2"
                                                    style="margin-bottom: 0px !important; max-width: 100%; text-overflow: ellipsis !important; white-space: nowrap; overflow: hidden;">
                                                    Atención del día: {{ item.activityDate | date:'dd/MM/yyyy HH:mm'}}
                                                </p>
                                            </div>
                                            <div>
                                                <p class="mat-font-xsmall-px pl-2"
                                                    style="margin-bottom: 0px !important; line-height: 0"
                                                    [ngStyle]="{'text-align': this.user.id === item.operatorId ? 'start' : 'start' }">
                                                    Prestador: {{ item.provider.name }} {{ item.provider.surname }}
                                                </p>
                                            </div>
                                        </div>
                                        <!-- UNDER THE CARD -->
                                        <div class="flex-row align-space-between-center gap-1em" style="max-width: 99%">
                                            <!-- Fecha y Hs -->
                                            <div class="flex-row card-items">
                                                <p class="flex-row align-end-end textTags"
                                                    style="line-height:-0.5;padding-left: 4px; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; "
                                                    [ngStyle]="{'text-align': this.user.id === item.operatorId ? 'end' : 'start' }">
                                                    {{ item.date | date:'dd/MM/yy HH:mm' }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                            <!-- ---- -->

                            <div [ngClass]="this.user.id ===entry?.value[0]?.operatorId ? 'myself' : 'other'"
                                class="flex-row">

                                <!-- CARD -->
                                <div #currentVersion class="flex-70 prs-2">
                                    <div>
                                        <mat-icon [style.width.px]="18" [style.height.px]="18"
                                            svgIcon="enter"></mat-icon>
                                        <span class="flex-1-1-auto pbs-1 pbs-10 subtitle-4 text-link">
                                            {{ ('modules.cases.evolutions-side-bar.card.text.current-version' | exp:'':'Versión actual')  }}
                                        </span>
                                    </div>
                                    <!-- USER-->
                                    <div class="flex-row flex-100 pl-1"
                                        [ngClass]="this.user.id === entry?.value[0]?.operatorId ? 'start-none' : 'none-none'"
                                        style="height:15px !important; align-items: center !important ; justify-content: flex-start !important; width: 90%;">
                                        <p class="operatorName"
                                            style="text-overflow: ellipsis !important; white-space: nowrap; overflow: hidden;">
                                            {{ entry?.value[0]?.operator.name }}</p>
                                        <p
                                            style="text-overflow: ellipsis !important; white-space: nowrap; padding-left: 1%;font-size: 10px !important">
                                            - {{ entry?.value[0]?.category.category == 'NOTA_' ? 'NOTA' :
                                            entry?.value[0]?.category.category
                                            }}</p>
                                    </div>
                                    <!-- TEXTO -->
                                    <div class="flex-row">
                                        <app-theme-card themeScope="cases" [fullWidth]="false" [cardClass]="{
                                                'bg-primary': this.user.id ===  entry?.value[0].operatorId,
                                                'bg-primary-100': this.user.id !==  entry?.value[0].operatorId,
                                                'noteDeleted':  !entry?.value[0].active
                                            }" [cardStyle]="{ 'border-radius': '10px', width: '350px' }">
                                            <mat-card-content class="mat-font-small-11px"
                                                [ngStyle]="{'color': this.user.id === entry?.value[0]?.operatorId ? 'white' : 'black' }"
                                                style="overflow-wrap: anywhere;"
                                                [innerHTML]="entry?.value[0]?.active ? entry?.value[0]?.text : ('modules.cases.evolutions-side-bar.nota-eliminada' | exp:'':'Nota eliminada') | safeHtml">
                                            </mat-card-content>
                                            @if(!!entry.value[0].hasMedia) {
                                            <div class="flex mat-font-small-11px p-4"
                                                [ngStyle]="{'color': this.user.id === entry?.value[0]?.operatorId ? 'white' : 'black' }"
                                                style="justify-content: end;font-size: 10px;">
                                                <span (click)="downloadMedia(entry?.value[0])"
                                                    *ngIf="(!evolutionIdGettingMedia || (entry?.value[0].id!==evolutionIdGettingMedia && isloadingGettingMedia)); else loadingGettinMedia"
                                                    style="cursor:pointer">
                                                    <u>{{ 'modules.cases.evolutions-side-bar.card.text.see-attached' | exp:'':'Ver adjunto' }}</u>
                                                </span>
                                                <ng-template #loadingGettinMedia>
                                                    <div class="custom-spinner">
                                                        <div class="spinner-circle"></div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                            }
                                        </app-theme-card>
                                        <button type="button" [matMenuTriggerFor]="menuActions"
                                            [matMenuTriggerData]="{ evolution: entry}"
                                            style="background-color: unset; border: unset; margin: 0;padding: 0 ; transform: translate(-10%,-10%);">
                                            <mat-icon class="cursor-pointer"
                                                [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'">
                                            </mat-icon>
                                        </button>
                                    </div>
                                    <!-- UNDER THE CARD -->
                                    <div class="flex-row align-space-between-center gap-1em" style="max-width: 99%">
                                        <!-- Fecha y Hs -->
                                        <div class="flex-row card-items">
                                            <p class="flex-row align-end-end textTags"
                                                style="line-height:-0.5;padding-left: 4px; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; "
                                                [ngStyle]="{'text-align': this.user.id === entry.value[0].operatorId ? 'end' : 'start' }">
                                                {{ entry?.value[0]?.date | date:'dd/MM/yy HH:mm' }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pbs-3 endLine">
                                <p style="border-bottom:1.5px solid var(--color-grey-light); font-size: small"></p>
                            </div>
                        </div>
                        <!-- ---------- -->

                        }@else {
                        <div [ngClass]="this.user.id === entry?.value[0]?.operatorId ? 'myself' : 'other'"
                            class="flex-row" style="height: 100%">
                            <!-- CARD -->
                            <div class="flex-100">
                                <!-- USER-->
                                <div class="flex-row flex-100 pl-1"
                                    [ngClass]="this.user.id === entry?.value[0]?.operatorId ? 'start-none' : 'none-none'"
                                    style="height:15px !important; align-items: center !important ; justify-content: flex-start !important; width: 90%;">
                                    <p title={{entry?.value[0]?.operator?.name}} class="operatorName flex-1"
                                        style="text-overflow: ellipsis !important; white-space: nowrap; overflow: hidden;">
                                        {{ entry?.value[0]?.operator?.name }}</p>
                                    <p class="flex-1"
                                        style="text-overflow: ellipsis !important; white-space: nowrap; padding-left: 1%;font-size: 10px !important">
                                        - {{ entry?.value[0]?.category.category == 'NOTA_' ? 'NOTA' :
                                        entry?.value[0]?.category.category
                                        }}
                                    </p>
                                    <!-- - CRÍTICA -->
                                    <p *ngIf="entry?.value[0]?.type == EVOLUTIONS_TYPE.CRITICAL" class="flex-1 subtitle-4 text-validation-error">
                                        - {{ ('modules.cases.evolutions-side-bar.critica' | exp:'':'- Crítica')  }}
                                    </p>
                                    <!-- Editada -->
                                    <div *ngIf="entry.value.length > 1" class="flex-1 pls-2"
                                        style="display: flex; align-items: center; justify-content: center; margin-left: auto;;z-index: 20000;"
                                        (click)="getHistoryWithId(entry.value[entry.value.length -1].id)">
                                        <mat-icon [style.width.px]="13" [style.height.px]="13"
                                            svgIcon="clockHistory"></mat-icon>
                                        <p
                                            style="text-overflow: ellipsis; white-space: nowrap; font-size: 10px;cursor: pointer;">
                                            {{ ('modules.cases.evolutions-side-bar.editada' | exp:'':'Editada') }}
                                        </p>
                                    </div>
                                </div>
                                <!-- TEXTO -->
                                <div class="flex-row">
                                    <app-theme-card themeScope="cases" [fullWidth]="false" [cardClass]="{
                                                'bg-primary': this.user.id ===  entry?.value[0].operatorId,
                                                'bg-primary-100': this.user.id !==  entry?.value[0].operatorId,
                                                'noteDeleted':  !entry?.value[0].active,
                                                'flex-column': true
                                            }" [cardStyle]="{ 'border-radius': '10px', width: '350px' }">
                                        <mat-card-content class="mat-font-small-11px"
                                            [ngStyle]="{'color': this.user.id === entry?.value[0]?.operatorId ? 'white' : 'black' }"
                                            style="overflow-wrap: anywhere;"
                                            [innerHTML]="entry?.value[0]?.active ? entry?.value[0]?.text : ('modules.cases.evolutions-side-bar.nota-eliminada' | exp:'':'Nota eliminada') | safeHtml">
                                        </mat-card-content>
                                        @if(!!entry.value[0].hasMedia){
                                        <div class="flex mat-font-small-11px p-4"
                                            [ngStyle]="{'color': this.user.id === entry?.value[0]?.operatorId ? 'white' : 'black' }"
                                            style="justify-content: end;font-size: 10px;">
                                            <span (click)="downloadMedia(entry?.value[0])"
                                                *ngIf="(!evolutionIdGettingMedia || (entry?.value[0].id!==evolutionIdGettingMedia && isloadingGettingMedia)); else loadingGettinMedia"
                                                style="cursor:pointer">
                                                <u>{{ 'modules.cases.evolutions-side-bar.card.text.see-attached' | exp:'':'Ver adjunto' }}</u>
                                            </span>
                                            <ng-template #loadingGettinMedia>
                                                <div class="custom-spinner">
                                                    <div class="spinner-circle"></div>
                                                </div>
                                            </ng-template>
                                        </div>
                                        }
                                    </app-theme-card>
                                    <!-- Note Actions Menu -->
                                    <button type="button" [matMenuTriggerFor]="menuActions"
                                        [matMenuTriggerData]="{ evolution: entry}"
                                        style="background-color: unset; border: unset; margin: 0;padding: 0 ; transform: translate(-10%,-10%);">
                                        <mat-icon class="cursor-pointer"
                                            [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'">
                                        </mat-icon>
                                    </button>
                                </div>
                                <!-- TEXTO SI HAY ATENCIÓN -->
                                <div *ngIf="entry?.value[0]?.attentionId" class="flex-column"
                                    [ngClass]="this.user.id === entry?.value[0]?.operatorId ? 'start-none' : 'none-none'">
                                    <div>
                                        <p class="mat-font-xsmall-px pl-2"
                                            style="margin-bottom: 0px !important; max-width: 100%; text-overflow: ellipsis !important; white-space: nowrap; overflow: hidden;">
                                            {{ 'modules.cases.evolutions-side-bar.atencion-del-dia' | exp:'':'Atencion del dia' }}: {{ entry?.value[0]?.activityDate | date:'dd/MM/yyyy HH:mm'}}</p>
                                    </div>
                                    <div>
                                        <p class="mat-font-xsmall-px pl-2"
                                            style="margin-bottom: 0px !important; line-height: 0"
                                            [ngStyle]="{'text-align': this.user.id === entry?.value[0]?.operatorId ? 'start' : 'start' }">
                                            {{ 'modules.cases.evolutions-side-bar.card.provider' | exp:'':'Prestador' }}: {{ entry?.value[0]?.provider?.name }} {{
                                            entry?.value[0]?.provider?.surname }}
                                        </p>
                                    </div>
                                </div>
                                <!-- ACCIONES -->
                                <div class="flex-row align-end-center  gap-1em" style="max-width: 91%">
                                    <div class="flex-row card-items">
                                        <p class="flex-row align-end-end textTags"
                                            style="line-height:-0.5;padding-left: 4px; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; "
                                            [ngStyle]="{'text-align': this.user.id === entry.value[0].operatorId ? 'end' : 'start' }">
                                            {{ entry?.value[0]?.date | date:'dd/MM/yy HH:mm' }}
                                        </p>
                                    </div>
                                    <!-- Fecha y Hs -->
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>

            <!-- FOOTER - Input Note -->
            <mat-progress-bar *ngIf="this.isLoadingCreatingEvolution || isLoadingGettingEvolutions || isLoadingUpdatingEvolution" [mode]="'indeterminate'"></mat-progress-bar>
            <div class="flex flex-100 align-end-end" style=" max-height: 2%;flex-wrap: wrap;">
                <!-- Btn Expand // Collapsed -->
                <button class="addNoteBtn" style="z-index: 100000;">
                    @if(noteFocus){
                    <mat-icon [style.width.px]="25" [style.height.px]="25" svgIcon="downArrow"
                        (click)="closeFocus($event)"></mat-icon>
                    }@else {
                    <mat-icon [style.width.px]="25" [style.height.px]="25" svgIcon="upArrow"
                        (click)="openFocus($event)"></mat-icon>
                    }
                </button>
            </div>
            <div class="flex-row caja-3">
                <!-- Spinner -->
                <div class="flex-column flex-90 p-2">
                    <!-- Note type -->
                    <div [@expandCollapse]="noteFocus ? 'expanded' : 'collapsed'">
                        <span class="subtitle-3">{{ 'modules.cases.evolutions-side-bar.header.placeholders.note-type' | exp:'':'Tipo de nota...' }} *</span>
                        <app-select-input class="flex" [name]="this.NOTE_TYPE" [form]="this.evolutionForm"[placeholder]="('modules.cases.evolutions-side-bar.select' | exp:'':'Seleccionar')" [elements]="this.evolutionCategories"
                            [calculateId]="this.calculateCategoryOfEvolutionId" [calculateName]="this.calculateCategoryOfEvolutionName">
                        </app-select-input>
                    </div>
                        <!-- Note area -->
                        <div (click)="openFocus($event)">
                            <app-text-area-input [name]="this.NOTE" [height]="noteFocus ? 90 : 20" [form]="this.evolutionForm" [placeholder]="('modules.cases.evolutions-side-bar.ingrese-nueva-nota' | exp:'':'Ingrese nueva nota')" [resize]="false" style="width: 100% !important;">
                            </app-text-area-input>
                        </div>

                    <div [@expandCollapse]="noteFocus ? 'expanded' : 'collapsed'" class="flex-row align-space-between-center " style="z-index: 1; position: relative;top: -10px; height: fit-content">
                        <app-checkbox-input class="flex-25" [form]="this.evolutionForm"
                            [tooltip]="('modules.cases.evolutions-side-bar.evolution-edit.critical-advise' | exp:'':'“Al marcarla como crítica, se generará una tarea y se enviará un mail al operador del caso.”')"
                            [label]="('modules.cases.evolutions-side-bar.critica' | exp:'':'- Crítica')" [labelPosition]="'before'"
                            [name]="this.IS_CRITICAL"></app-checkbox-input>
                        <div class=" flex-row align-center-center gap-1em pbs-1"
                            style="font-size: 12px; text-align:left;justify-content: end;">
                            @if(evolutionForm.get(this.NOTE_MEDIA).value === ''){
                            <span (click)="openFileDialog($event)" style="cursor: pointer; font-size: 13.5px;">
                                <u>{{ 'modules.cases.evolutions-side-bar.note-area.attach-file' | exp:'':'Adjuntar archivo' }}</u></span>
                            <mat-icon style="cursor: pointer;" (click)="openFileDialog($event)" [style.width.px]="18"
                                [style.height.px]="18" svgIcon="paperclip"></mat-icon>
                            <input type="file" #fileInput style="opacity: 0; position: absolute; left: -9999px;"
                                (change)="onFileSelected($event)" accept=".jpg,.jpeg,.png,.pdf">
                            }
                            @if(evolutionForm.get(this.NOTE_MEDIA).value !== ''){
                            <span (click)="previewMedia()" style="font-size: 14px;cursor: pointer">
                                <u>{{selectedFileName}}</u></span>
                            <mat-icon [style.width.px]="18" [style.height.px]="18" (click)="onPressDeleteFile($event)"
                                [svgIcon]="'Delete-enabled-primary-22x22'" style="cursor: pointer;"></mat-icon>
                            }
                        </div>
                    </div>

                </div>
                <div class="flex-column flex-5 p-2" style="align-items: center;">

                    <div class="flex-100 submitBtn">
                        <!-- Submit Btn -->

                        <button [disabled]="!evolutionForm.valid" id="evolutionsSideBarComponent_btnAddEvolution" type="submit" [matTooltip]="('modules.cases.evolutions-side-bar.note-area.tooltips.add-note' | exp:'':'Presione para crear la nota')" mat-icon-button >
                            <mat-icon class="text-primary" [svgIcon]="evolutionForm.valid ? 'Send-enabled-primary-22x22' : 'Send-disabled-22x22'"></mat-icon>
                        </button>
                    </div>
                </div>

            </div>
            <!-- -- -->
        </div>
    </form>
</div>

<!-- Card -> Right Actions Menu -->
<mat-menu #menuActions="matMenu">
    <ng-template matMenuContent let-evolution="evolution">
        <button mat-menu-item (click)="this.openDialogModifyEvolution(evolution.value[0])" id="patchNote"
            style="font-size: smaller;">
            <span style="font-size: smaller;">{{ ('modules.cases.evolutions-side-bar.gestionar' | exp:'':'Gestionar') }}</span>
        </button>
        <button mat-menu-item (click)="evolution.value[0].active
          ? deleteNote(evolution.value[0])
          : restoreNote(evolution.value[0])" id="deleteNote">
            <span style="font-size: smaller;">
                {{evolution.value[0].active ? ('modules.cases.evolutions-side-bar.eliminar-nota' | exp:'':'Eliminar nota') : ('modules.cases.evolutions-side-bar.restaurar-nota' | exp:'':'Restaurar nota')}}
            </span>
        </button>
    </ng-template>
</mat-menu>

<!-- Add evolution with reference id (EDIT) -->
<ng-template #addEvolutionForCase>
    <div class="flex-column">
        <div class="flex-row flex-100 align-start-center">
            <div class="flex-row flex-30 align-start-center gap-20p">
                <div class="flex-20 mls-2">
                    <mat-icon [ngClass]="{'text-primary-darker': this.case.active,'text-secondary': !this.case.active}"
                        class="mat-icon-extraLarge">assignment</mat-icon>
                </div>
                <div class="flex-column">
                    <span class="mat-h2 mb-0 text-secondary-darker">
                        {{ this.case.id }}
                    </span>
                    <span class="text-secondary">
                        {{this.case.active ? ('modules.cases.evolutions-side-bar.caso-abierto' | exp:'':'Caso abierto') : ('modules.cases.evolutions-side-bar.caso-cerrado' | exp:'':'Caso cerrado')}}
                    </span>
                </div>
            </div>
            <div class="flex-row flex-30 align-start-center">
                <div class="flex-20 mls-2">
                    <mat-icon [ngClass]="{'text-primary-darker': this.case.active,'text-secondary': !this.case.active}"
                        class="mat-icon-extraLarge">person_pin</mat-icon>
                </div>
                <div class="flex-column">
                    <span class="mat-h2 mb-0 text-secondary-darker">
                        {{ this.case.patient.surname }}, {{ this.case.patient.name }}
                    </span>
                    <span class="text-secondary">{{ this.case.patient.typeDocument ?
                        this.case.patient.typeDocument : (('modules.cases.evolutions-side-bar.evolution-edit.dni' | exp:'':'DNI'))}}
                        {{ this.case.patient.documentNumber ? this.case.patient.documentNumber : ('modules.cases.evolutions-side-bar.evolution-edit.no-data' | exp:'':'Sin datos')}}
                    </span>
                </div>
            </div>
        </div>
        <div class="separator separator-center mts-5">
            <span class="mx-2 text-primary-darker">
                {{ 'modules.cases.evolutions-side-bar.evolution-edit.evolution-data' | exp:'':'Datos de la evolución' }}
            </span>
        </div>
        <div class="flex-row align-start-center mts-2">
            <form class="flex-100 flex-row wrap align-space-between-start gap-5p" [formGroup]="addEvolutionForm">
                <div class="flex-column flex-60">
                    <!-- ------------------VERSIONES ANTERIORES+++++++++++++++++ -->
                    <div #historyScroll style="height: 25%;overflow-y: scroll;">
                        <div *ngFor="let item of getFlattenedEvolutions().reverse()" class="prs-2">
                            <div [ngClass]="this.user.id === item.operatorId ? 'myself' : 'other'" class="flex-row"
                                style="opacity: 0.75;">
                                <!-- CARD -->
                                <div class="flex-100">
                                    <!-- USER-->
                                    <div class="flex-row flex-100 pl-1"
                                        [ngClass]="this.user.id === item.operatorId ? 'start-none' : 'none-none'"
                                        style="height:15px !important; align-items: center !important ; justify-content: flex-start !important; width: 90%;">
                                        <p class=" flex-1 operatorName"
                                            style="text-overflow: ellipsis !important; white-space: nowrap; overflow: hidden;">
                                            {{ item.operator.name }}
                                        </p>
                                        <p class="flex-1"
                                            style="text-overflow: ellipsis !important; white-space: nowrap; padding-left: 1%;font-size: 10px !important">
                                            - {{ item.category.category == 'NOTA_' ? 'NOTA' : item.category.category
                                            }}
                                        </p>
                                    </div>

                                    <!-- TEXTO -->
                                    <div class="flex-row">
                                        <app-theme-card themeScope="cases" [fullWidth]="false"
                                            [cardStyle]="{ 'border-radius': '10px', width: '50%', 'background-color': 'var(--color-surface-grey)' }">
                                            <mat-card-content class="mat-font-small-11px text-body"
                                                style="overflow-wrap: anywhere;"
                                                [innerHTML]="item.active ? item.text : ('modules.cases.evolutions-side-bar.nota-eliminada' | exp:'':'Nota eliminada') | safeHtml">
                                            </mat-card-content>
                                            @if(!!item.hasMedia){
                                            <div class="flex mat-font-small-11px p-4" (click)="downloadMedia(item)"
                                                style="justify-content: end;font-size: 10px;">
                                                <span class="text-body" style="cursor:pointer;">
                                                    <u>{{ 'modules.cases.evolutions-side-bar.card.text.see-attached' | exp:'':'Ver adjunto' }}</u>
                                                </span>
                                            </div>
                                            }
                                        </app-theme-card>
                                    </div>
                                    <!-- UNDER THE CARD -->
                                    <div class="flex-row align-end-center card-items" style="max-width: 97%">
                                        <!-- Fecha y Hs -->
                                        <p class="flex-row align-end-end textTags"
                                            style="line-height:-0.5;padding-left: 4px; text-overflow: ellipsis; white-space: nowrap; font-size: 10px; "
                                            [ngStyle]="{'text-align': this.user.id === item.operatorId ? 'end' : 'start' }">
                                            {{ item.date | date:'dd/MM/yy HH:mm' }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- -------------------------------------------------------------------- -->
                    <app-text-area-input class="flex-100" [clearable]="true" [form]="this.addEvolutionForm"
                        [name]="this.ADD_EVOLUTION_TEXT" [placeholder]="('modules.cases.evolutions-side-bar.evolution-edit.placeholders.input-evolution-text' | exp:'':'Ingrese el texto de la evolución')"
                        id="EvolutionCreateDialogComponent_txtArea" (change)="onChangeDescription($event)">
                    </app-text-area-input>
                    <div class="flex-row align-start-center flex-100"
                        style="z-index: 1; position: relative;top: -10px; height: fit-content; ">
                        <app-checkbox-input class="flex-15" [form]="this.addEvolutionForm" [label]="('modules.cases.evolutions-side-bar.critica' | exp:'':'- Crítica')"
                            [labelPosition]="'before'" [name]="this.ADD_EVOLUTION_CRITICAL"></app-checkbox-input>
                        <span *ngIf="this.addEvolutionForm.get(this.ADD_EVOLUTION_CRITICAL).value" class="flex- subtitle-4 text-validation-error">
                            <i>{{ 'modules.cases.evolutions-side-bar.evolution-edit.critical-advise' | exp:'':'“Al marcarla como crítica, se generará una tarea y se enviará un mail al operador del caso.”' }}</i>
                        </span>
                    </div>
                    <div>
                    </div>
                </div>
                <div class="flex-35 flex-column wrap">
                    <ng-container *ngIf="!this.updatingEvolution; else updateEvolution">
                        <app-select-input [name]="this.ADD_EVOLUTION_TYPE" [form]="this.addEvolutionForm"
                            [placeholder]="('modules.cases.evolutions-side-bar.evolution-edit.placeholders.evolution-type' | exp:'':'Tipo de evolución')" [elements]="this.listEvolutionTypes"
                            [calculateId]="this.calculateId" [calculateName]="this.calculateName"
                            (selected)="onSelectCategory($event)" id="EvolutionCreateDialogComponent_cmbCategories">
                        </app-select-input>
                    </ng-container>
                    <ng-template #updateEvolution>
                        <span class="text-secondary-darker">
                            {{ 'modules.cases.evolutions-side-bar.evolution-edit.placeholders.evolution-type' | exp:'':'Tipo de evolución' }}
                        </span>
                        <span class="text-secondary">
                            {{ this.evolutionToUpdate.category.category }}
                        </span>
                    </ng-template>
                    <file-pond #myPond [options]="pondOptions" (oninit)="pondHandleInit()"
                        (onaddfile)="pondHandleAddFile($event)" (onremovefile)="pondHandleRemoveFile($event)"
                        (onaddfilestart)="pondHandleProcessFile($event)"
                        id="EvolutionCreateDialogComponent_fileSelector">
                    </file-pond>
                </div>
            </form>
        </div>
        <div class="flex-row align-space-around-stretch mts-2">
            <button mat-stroked-button [color]="'primary'" [disabled]="this.loadingConfirm" (click)="onCancelClick()"
                id="EvolutionCreateDialogComponent_btnCancel">
                {{ ('common.cancel' | exp:'':'Cancelar')  }}
            </button>
            <button mat-flat-button [color]="'primary'" [disabled]="!addEvolutionForm.valid || !confirmBtn"
                (click)="onConfirmClick()" id="EvolutionCreateDialogComponent_btnConfirm">
                <span *ngIf="!this.loadingConfirm; else loadingConfirmIcon">
                    {{ ('common.confirm' | exp:'':'Confirmar')  }}
                </span>
                <ng-template #loadingConfirmIcon>
                    <mat-icon>
                        <mat-spinner color="accent" diameter="20">
                        </mat-spinner>
                    </mat-icon>
                </ng-template>
            </button>
        </div>
    </div>
</ng-template>
